var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopNavCompose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 35 35"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.431 1.569A5.172 5.172 0 0029.75.044a5.17 5.17 0 00-3.681 1.525L9.006 18.63c-.09.09-.16.2-.203.32l-3.5 9.625a.875.875 0 001.121 1.121l9.625-3.5a.875.875 0 00.32-.203L33.43 8.93a5.172 5.172 0 001.525-3.681 5.17 5.17 0 00-1.525-3.681zM15.27 24.619l-7.68 2.793 2.792-7.68L24.5 5.612l4.888 4.888-14.12 14.12zM32.194 7.694l-1.569 1.569-4.888-4.888 1.57-1.569a3.433 3.433 0 012.443-1.012c.923 0 1.791.36 2.444 1.012a3.434 3.434 0 011.012 2.444c0 .923-.36 1.791-1.012 2.444z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 35h-28A2.628 2.628 0 010 32.375v-28A2.628 2.628 0 012.625 1.75h17.5a.875.875 0 010 1.75h-17.5a.876.876 0 00-.875.875v28c0 .482.393.875.875.875h28a.876.876 0 00.875-.875v-17.5a.875.875 0 011.75 0v17.5A2.628 2.628 0 0130.625 35z"
  }))));
}

export default SvgTopNavCompose;